import { apiPaths } from '@/services/api/paths';
import { TRosterUserPeerSupportCertificateInfo } from '@/types/Roster.types';
import { api, TCustomAxiosResponse } from '..';

export const upgradeMemberToPeerSupportPost = async (
  organizationId: string,
  userId: string,
  peerSupportUpgradeInfo: TRosterUserPeerSupportCertificateInfo,
) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(
    apiPaths.organization.upgradeToPeerSupport(organizationId, userId),
    {
      certificateId: peerSupportUpgradeInfo.certificateId,
      validationStartDate: peerSupportUpgradeInfo.dateOfIssue,
      validationEndDate: peerSupportUpgradeInfo.validUntil,
    },
  );

  return data.data;
};

export const downgradePeerSupportToMemberPost = async (organizationId: string, userId: string) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(
    apiPaths.organization.downgradeToEmployee(organizationId, userId),
  );

  return data.data;
};

export const assignPeerSupportLeadPost = async (organizationId: string, userId: string) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(
    apiPaths.organization.assignPeerSupportLead(organizationId, userId),
  );

  return data.data;
};

export const revokePeerSupportLeadPost = async (organizationId: string, userId: string) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(
    apiPaths.organization.revokePeerSupportLead(organizationId, userId),
  );

  return data.data;
};
